export const AI_ASSISTANT_SUPPORTED_FILE_TYPES = [
  'pdf',
  'csv',
  'doc',
  'docx',
  'odp',
  'ods',
  'odt',
  'pot',
  'potm',
  'potx',
  'pps',
  'ppsx',
  'ppsxm',
  'ppt',
  'pptm',
  'pptx',
  'rtf',
  'xls',
  'xlsx',
];
